export default {"src":"/_next/static/media/chevronUp.f52bb183.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};